import styled from 'styled-components';

export const ListItem = styled.li`
  margin-top: 20px;
`;
